import axios from 'axios'
import { camelizeKeys, decamelizeKeys, decamelize } from 'humps'

import PATHS from '@constants/paths'

const DEFAULT_ERROR_MESSAGE = 'Oops! Something went wrong. Please try again.'

const transformRequest = (data, headers) => {
  if (data instanceof window.FormData) {
    // eslint-disable-next-line no-param-reassign
    headers['Content-Type'] = 'multipart/form-data'

    const newRequest = new window.FormData()
    data.forEach((value, key) => newRequest.append(decamelize(key), value))

    return newRequest
  }

  return decamelizeKeys(data)
}

const transformResponse = (data) => camelizeKeys(data)

const handleError = (error) => {
  const errorMessage = error.response?.data?.error || DEFAULT_ERROR_MESSAGE
  const status = error.response?.status

  if (status === 401) {
    window.location.href = PATHS.unauthorized
  }

  return Promise.reject(new Error(errorMessage))
}

const ApiService = axios.create({
  transformRequest: [transformRequest].concat(axios.defaults.transformRequest),
  transformResponse: axios.defaults.transformResponse.concat([transformResponse]),
})

ApiService.interceptors.response.use((response) => response, handleError)

export default ApiService
